// window.addEventListener("message", function(event) {
//   if (event.data.event === "nazhi_postcookies") {
// 		window.localStorage.setItem('wlnwms_cookies')
//   }
// });
if (window.config.chrome && window.config.chrome.eventlistener) {
	window.addEventListener("message", (event)=>{
		window.config.chrome.eventlistener(event)
	})
	
}

import '@/config.js'
import Vue from 'vue'
import Vuex from 'vuex'
import App from '@_system/App.vue'
import router from '@_system/router/index.js'
import Vant from 'vant';
import {
	Dialog,
	Notify,
	Toast,
} from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui'
import {
	Message,
	MessageBox,
	Notification,
	Loading,
} from 'element-ui'

import Store from '@/store/store.js'
import Api from '@/api/api.js'
import VXETable from 'vxe-table'
import XLSX from 'xlsx-js-style'
import {
	VueHammer
} from 'vue2-hammer'
VXETable.setup({
	size: 'mini',
	modal: {
		size: 'mini',
	}
})


import 'vxe-table/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css';



import '@_system/lib/scss/vxe.scss'
import '@_system/lib/scss/element.scss'
import '@_system/lib/scss/vant.css'
import '@_system/lib/css/common.css'

import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)
import Contextmenu from "vue-contextmenujs"
Vue.use(Contextmenu);

import formwindow from '@_system/components/forms/window/formwindow.vue'
import Avatar from '@_system/components/Avatar.vue'
import phoneGrid from '@_system/components/base/phone/grid/grid.vue'
import buttonauth from '@_system/components/base/buttonauth.vue'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import VueNativeSock from 'vue-native-websocket'
import Print from 'vue-print-nb'
const lodash = require('lodash')

document.title = window.config.title
Vue.use(VueNativeSock, '', {
	connectManually: true,
	reconnection: true,
	reconnectionAttempts: 5,
	reconnectionDelay: 3000,
	format: 'json',
})

require('@_system/common/index.js')
require('@_system/components/formcomponents/index.js')

// import VConsole from 'vconsole';
// window.vConsole = new VConsole()

window.systemData = {
	emun: []
}

const demo = () => {
	alert(123)
}
window.demo = demo
//require('./mock/mock.js')
window.onlineList = []
window.Vue = Vue
Vue.config.productionTip = false
Vue.prototype.$lg = function(param) {
	window.console.log(param)
}
Vue.prototype.$api = Api
Vue.prototype.$VXETable = VXETable
Vue.prototype.$XLSX = XLSX
Vue.prototype.$Lodash = lodash
Vue.prototype.$Moment = moment
Vue.use(Vant)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VXETable)
Vue.use(formCreate)
Vue.use(FcDesigner)
Vue.use(XLSX)
Vue.use(VueClipboard)
VXETable.use(VXETablePluginElement)
VXETable.use(VXETablePluginExportXLSX)
Vue.use(Print)
Vue.use(VueHammer)

Vue.component('formwindow', formwindow)
Vue.component('Avatar', Avatar)
Vue.component('phoneGrid', phoneGrid)
Vue.component('buttonauth', buttonauth)




Vue.prototype.$message = (option) => {
	if (window.systemMethods.device() != 'pc') {
		return Notify(option)
	} else {
		return Message(option)
	}
}
Vue.prototype.$message.success = (message) => {
	if (window.systemMethods.device() != 'pc') {
		return Notify({
			type: 'success',
			message: message
		})
	} else {
		return Message.success(message)
	}
}
Vue.prototype.$message.error = (message) => {
	if (window.systemMethods.device() != 'pc') {
		return Notify({
			type: 'danger',
			message: message
		})
	} else {
		return Message.error(message)
	}
}

Vue.prototype.$notify = (option) => {
	if (window.systemMethods.device() != 'pc') {
		if (!option.dangerouslyUseHTMLString) {
			return Notify({
				type: option.type,
				message: option.message
			})
		}
		return false
	} else {
		return Notification(option)
	}
}


Vue.prototype.$confirm = (message, title = '提示', option) => {
	if (window.systemMethods.device() != 'pc') {
		return Dialog.confirm({
			message: message,
			title: title,
			...option
		})
	} else {
		return MessageBox.confirm(message, title, option)
	}
}

Vue.prototype.$prompt = (message, title = '提示', option) => {
	if (window.systemMethods.device() != 'pc') {
		return Dialog.confirm({
			title,
			message,
			...option
		})
	} else {
		return MessageBox.prompt(message, title, option)
	}
}

Vue.prototype.$loading = (target = null, message = '加载中...') => {
	if (window.systemMethods.device() != 'pc') {
		return Toast.loading({
			message: message,
			forbidClick: true,
		});
	} else {
		return Loading.service({
			target: target ? target : 'body',
			lock: true,
			text: message,
			spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255, 0.5)'
		})
	}
}
Vue.prototype.$loadingclose = (handle) => {
	if (window.systemMethods.device() != 'pc') {
		handle.clear()
	} else {
		handle.close()
	}
}





// window.difyChatbotConfig = window.config.difyChatbotConfig
// if (window.difyChatbotConfig) {
// 	let difyToken = window.difyChatbotConfig.token
// 	const existingScript = document.getElementById(difyToken);
// 	if (!existingScript) {
// 		const script = document.createElement('script');
// 		script.src = window.difyChatbotConfig.baseUrl + '/embed.min.js';
// 		script.id = difyToken;
// 		script.defer = true;
// 		script.onload = () => {
// 			console.log('Dify Chatbot script loaded.');
// 		};
// 		script.onerror = (error) => {
// 			console.error('Failed to load Dify Chatbot script:', error);
// 		};

// 		// 动态插入脚本
// 		document.body.appendChild(script);
// 	} else {
// 		console.log('Dify Chatbot script already exists.');
// 	}
// }




const store = new Vuex.Store(Store.store)
store.state.app = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')